import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

export const SectionHero = () => {
  const scrollToNextSection = () => {
    const nextSection = document.getElementById("welcome");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    return () => {
      window.scrollTo(0, 0);
    };
  }, []);

  const socialMedia = [
    { icon: faFacebook, link: "#" },
    { icon: faInstagram, link: "https://www.instagram.com/mountainmarathonfestival/" },
    { icon: faTwitter, link: "#" },
  ];

  return (
    <section
      id="hero"
      className="w-full min-h-screen text-black text-center flex flex-col justify-center relative overflow-hidden"
      style={{
        backgroundImage: "url('/bg/java.jpg')",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* === EFEK ZOOM-IN (TANPA MENGGANGGU BACKGROUND ASLI) === */}
      <motion.div
        className="absolute inset-0 z-1 pointer-events-none"
        style={{
          backgroundImage: "url('/bg/java.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
        initial={{ scale: 1 }}
        animate={{ scale: 1.25 }}
        transition={{
          duration: 12,
          ease: "easeOut",
        }}
      />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-gray-600/100 to-gray-600/20 z-5"></div>

      {/* Ikon Media Sosial */}
      <div className="absolute left-4 top-1/2 transform -translate-y-1/2 z-20 hidden md:flex flex-col items-center gap-4">
        {socialMedia.map((social, index) => (
          <motion.a
            key={index}
            href={social.link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-white text-xl sm:text-2xl bg-opacity-50 w-8 h-8 sm:w-8 sm:h-8 flex items-center justify-center rounded-full hover:text-yellow-200 transition-colors"
            initial={{ opacity: 0, y: -15 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.8,
              delay: 0.7 + index * 0.1,
              ease: [0.4, 0, 0.2, 1],
            }}
            viewport={{ once: true }}
          >
            <FontAwesomeIcon icon={social.icon} />
          </motion.a>
        ))}
      </div>

      {/* Logo & Title */}
      <div className="relative text-white text-center z-10 flex flex-col justify-center flex-grow gap-8">
        <motion.div
          className="py-2 flex justify-center"
          initial={{ opacity: 0, y: -15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3, ease: [0.4, 0, 0.2, 1] }}
          viewport={{ once: true }}
        >
          <img
            src="logo/mmf.png"
            alt="MMF"
            className="w-auto h-10 sm:h-16 md:h-16 lg:h-20 object-contain"
          />
        </motion.div>

        <motion.h2
          className="text-lg font-normal text-white max-w-[700px] mx-auto px-4 leading-relaxed"
          initial={{ opacity: 0, y: -15 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6, ease: [0.4, 0, 0.2, 1] }}
          viewport={{ once: true }}
        >
          Experience the ultimate mountain trail running challenge across three
          spectacular Indonesian locations. Join hundreds of athletes in
          conquering volcanic peaks, ancient forests, and sacred mountains.
        </motion.h2>
      </div>

      {/* Scroll Down */}
      <div className="absolute bottom-8 left-0 w-full flex justify-center z-20">
        <motion.div
          className="cursor-pointer text-white animate-bounce"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeInOut" }}
          onClick={scrollToNextSection}
        >
          <FontAwesomeIcon icon={faChevronDown} className="text-4xl" />
        </motion.div>
      </div>
    </section>
  );
};
